import i18next from "i18next";

import { createColumn } from "../../../../../../components/Table";
import { getWardLabel } from "../../../../../../utils/wardLabel";

export const hospitalTableColumns = [
  createColumn({
    keyName: "hospitalId",
    header: () =>
      i18next.t("surveys_list_wardId", { ward: getWardLabel().singular }),
    cell: (info) => info.renderValue(),
    size: 90,
  }),
  createColumn({
    keyName: "hospitalName",
    header: () =>
      i18next.t("surveys_list_wardName", { ward: getWardLabel().singular }),
    cell: (info) => info.renderValue(),
    size: 300,
  }),
  createColumn({
    keyName: "action",
    header: () => i18next.t("surveys_list_assign"),
    cell: (info) => info.renderValue(),
    size: 30,
  }),
];
